<template>
  <div class="studio-community-chat-room-item">
    <div
      class="d-flex room__content pl-3 pr-3 pt-3 pb-1"
      :class="{ active: isActive }"
    >
      <div class="d-flex mb-3 mr-3">
        <HMImagesStack :images="chatRoomMemberPhotos" size="36px" />
        <div
          v-if="chatroom.unreadCount"
          class="room__sub-icon-bg d-flex align-items-center justify-content-center smaller"
        >
          {{ chatroom.unreadCount }}
        </div>
      </div>
      <div class="d-flex w-100 justify-content-between overflow-hidden">
        <span
          class="c-charcoal text-truncate mw-75"
          :class="{ 'font-weight-bold': chatroom.unreadCount > 0 }"
        >
          {{ roomName }}
        </span>
        <span class="smaller text-nowrap">{{ date }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import { mapGetters } from 'vuex';
import { getAvatarURL } from '@/core/utils/utils';

export default Vue.extend({
  name: 'StudioCommunityChatRoomItem',
  props: {
    chatroom: {
      type: Object,
      required: true,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      user: 'user/user',
      studio: 'studio/currentStudio',
    }),
    chatRoomPhoto() {
      let image = null;
      if (this.chatroom.image) {
        image = this.chatroom.image;
      } else if (this.chatroom.is_private) {
        const otherMember =
          this.chatroom?.members?.find(
            member => member.id != this.user.community_profile_id
          ) || {};
        image = otherMember.image;
      } else {
        const adminMember =
          this.chatroom?.members?.find(member => member.is_admin) || {};
        image = adminMember.image;
      }
      return { image };
    },
    date() {
      return moment(this.chatroom.updated || this.chatroom.created).fromNow();
    },
    roomName() {
      if (this.chatroom?.room_name) return this.chatroom.room_name;
      let members = this.chatroom?.members;
      if (this.chatroom?.is_private) {
        members = members.filter(
          member => member.id !== this.user.community_profile_id
        );
      }
      return (members || []).map(member => member.first_name).join(', ');
    },
    getMembersCount() {
      if (!this.chatroom?.members) return 0;
      return this.chatroom.members.length;
    },
    getLimitedMembers() {
      if (!this.chatroom?.members) return [];
      return [...this.chatroom.members].splice(0, 5);
    },
    chatRoomMemberPhotos() {
      let images = [];
      if (this.chatroom.image) {
        images.push({ url: this.chatroom.image });
      } else if (this.chatroom.is_private) {
        const otherMember =
          this.chatroom?.members?.find(
            member => member.id != this.user.community_profile_id
          ) || {};
        images.push(this.memberToImage(otherMember));
      } else {
        const membersImages = this.getLimitedMembers.map(member => {
          return this.memberToImage(member);
        });
        images = membersImages;
      }
      return images;
    },
  },
  methods: {
    shortenText(text, length = 20) {
      if (!text) return '';
      if (text.length < length) return text;

      return `${text.substring(0, length)}...`;
    },
    memberToImage(member) {
      const name = `${member.first_name} ${member.last_name}`;
      return {
        url:
          member.image ||
          getAvatarURL(name, this.studio.primary_color, 'white', 20, '36px'),
        tooltip: name,
      };
    },
  },
});
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.room {
  &__content:hover,
  &__content.active {
    cursor: pointer;
    border-radius: $border-radius;
    background-color: #eff2f5;
  }

  &__icon-block {
    position: relative;
    width: 48px;
    height: 48px;
  }

  &__icon {
    border-radius: 50%;
    width: 48px;
    height: 48px;
  }

  &__sub-icon-bg {
    background-color: var(--brand-color, #f26c67);
    height: 19px;
    width: 19px;
    border-radius: 50%;
    border: 2px solid #ffffff;
    text-align: center;
    font-size: 8px;
    font-weight: 700;
    font-family: 'Poppins';
    color: #ffffff;
    position: relative;
    bottom: -20px;
    right: 7px;
    padding-top: 2px;
  }

  &__sub-icon {
    color: $white;
    left: 0;
    right: 0;
    position: absolute;
    font-weight: 500;
  }

  &__text {
    font-size: 12px;
    color: $dark-gray;
  }
}
.mw-75 {
  max-width: 75%;
}
</style>
